<template>
    <div>
        <p class="mb-3 text-center">
            <slot name="labelText">{{ translate('Credits') }}:</slot>
            <br />
            <strong class="font-size-125">{{ selectedCreditsReadable }}</strong>
        </p>
        <div class="px-5 pb-4">
            <VueSlider
                v-model="selectedCredits"
                :adsorb="true"
                :marks="getMark"
                tooltip="none"
                :clickable="true"
                :drag-on-click="true"
                :disabled="disabled"
                :data="Object.keys(selectableCredits)"
                :process="getProcess"
                :duration="0"
            ></VueSlider>
        </div>
    </div>
</template>

<script>
import VueSlider from 'vue-slider-component';
import 'vue-slider-component/theme/default.css';
import TransFilter from '../../../../../qaamgo/modules/sat/components/mixins/TransFilter';

export default {
    name: 'SelectCreditsSlider',
    components: { VueSlider },
    mixins: [TransFilter],
    props: {
        selectableCredits: {
            type: Object,
            required: true,
        },
        value: {
            type: String,
            default: '250',
        },
        disabled: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        selectedCreditsReadable() {
            return this.selectableCredits[this.selectedCredits];
        },
    },
    watch: {
        selectedCredits(credits, oldCredits) {
            if (credits === oldCredits) {
                // no need to emit event if the value didn't change
                return;
            }

            this.$emit('input', credits);
        },
    },
    methods: {
        getProcess(dotsPos) {
            return [[0, dotsPos[0], { backgroundColor: '#4285f4' }]];
        },
        getMark(value) {
            if (!this.selectableCredits[value]) {
                return {
                    label: '',
                };
            }

            return {
                label: this.selectableCredits[value],
            };
        },
    },
    data() {
        return {
            selectedCredits: this.value,
        };
    },
};
</script>
